import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20amber%20and%20orange%20gradient%20abstract%20background%20with%20flowing%20organic%20curves%2C%20soft%20geometric%20patterns%20overlay%2C%20minimal%20modern%20design%20with%20gentle%20light%20leaks%2C%20clean%20aesthetic%2C%204k%20quality&width=1800&height=500&seq=cta-magnet-bg&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 to-primary-700/85"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          还没找到想要的磁力网站？
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 leading-relaxed">
          告诉我们你的需求，我们会持续收录更多优质磁力网站，不断完善导航服务。
          你也可以直接推荐你发现的好网站，帮助更多人。
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-background-50 text-primary-700 font-medium text-sm hover:bg-background-50/90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-send-plane-fill text-lg"></i>
          推荐磁力网站
        </Link>
      </div>
    </section>
  );
}